"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var ModalBody_1 = __importDefault(require("./ModalBody"));
var NewModalFooter_1 = __importDefault(require("./NewModalFooter"));
var NewModalHeader_1 = __importDefault(require("./NewModalHeader"));
var NewModalWrapper_1 = __importDefault(require("./NewModalWrapper"));
var NewModal = function (_a) {
    var onClose = _a.onClose, title = _a.title, subTitle = _a.subTitle, icon = _a.icon, iconColor = _a.iconColor, footerContent = _a.footerContent, textAlign = _a.textAlign, children = _a.children, maxWidth = _a.maxWidth, open = _a.open, onBackdropClick = _a.onBackdropClick;
    return ((0, jsx_runtime_1.jsxs)(NewModalWrapper_1.default, __assign({ maxWidth: maxWidth, onClose: onClose, open: open, onBackdropClick: onBackdropClick }, { children: [(0, jsx_runtime_1.jsx)(NewModalHeader_1.default, { subTitleTextAlign: textAlign, icon: icon, iconColor: iconColor, subTitle: subTitle, title: title }), children && (0, jsx_runtime_1.jsx)(ModalBody_1.default, __assign({ textAlign: textAlign !== null && textAlign !== void 0 ? textAlign : 'center' }, { children: children })), footerContent && (0, jsx_runtime_1.jsx)(NewModalFooter_1.default, { children: footerContent })] })));
};
exports.default = NewModal;
